import clsx from "clsx";
import { twMerge } from "tailwind-merge";

import { TertiaryIcon } from "@components/v2/buttons/buttons.stories";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

interface Props {
  id: string;
  label: string;
  disabled?: boolean;
  onRemove: () => void;
}

export const BreakdownItem = ({ id, label, disabled, onRemove }: Props) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: id,
    disabled,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={clsx(
        "w-48 h-9 border rounded flex items-center gap-2 px-3",
        "bg-v2-primary hover:border-v2-primary group",
        {
          "border-v2-secondary": !isDragging,
          "border-v2-primary shadow-md z-[1]": isDragging,
        },
      )}
    >
      <div
        ref={setActivatorNodeRef}
        {...attributes}
        {...listeners}
        className={clsx("shrink-0", { "pointer-events-none": disabled })}
      >
        <i
          className={twMerge(
            clsx(
              "fa-solid fa-grip-dots-vertical text-v2-secondary",
              "text-base opacity-25",
              {
                "cursor-grab group-hover:opacity-100": !disabled,
                "cursor-grabbing opacity-100": isDragging,
              },
            ),
          )}
        ></i>
      </div>
      <div className="text-sm truncate flex-1">{label}</div>
      <TertiaryIcon
        disabled={disabled}
        className={clsx("shrink-0 w-6 h-6 hidden", {
          "group-hover:block": !isDragging,
        })}
        onClick={() => {
          onRemove();
        }}
      >
        <i
          className={clsx("fa-regular fa-trash", {
            "text-mars": !disabled,
            "text-v2-disabled": disabled,
          })}
        ></i>
      </TertiaryIcon>
    </div>
  );
};
